import { render } from "./Confirmation.vue?vue&type=template&id=51d3705b"
import script from "./Confirmation.vue?vue&type=script&setup=true&lang=js"
export * from "./Confirmation.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/www/html/lasource-2023/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/cartes-cadeaux/pages/Confirmation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "51d3705b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('51d3705b', __exports__)) {
    console.log('reload')
    api.reload('51d3705b', __exports__)
  }
  
  module.hot.accept("./Confirmation.vue?vue&type=template&id=51d3705b", () => {
    console.log('re-render')
    api.rerender('51d3705b', render)
  })

}


export default __exports__